import {RouterProps} from "../../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    UiHomeContentUserProductionValueObject
} from "../../../../../data/value-object/ui/UiHomeContentUserProductionValueObject";
import {useEffect} from "react";
import {UiHomeContentUserProductionIO, UiHomeContentUserProductionModificationIO} from "../../../../../io/UiIO";
import {StorageKey} from "../../../../../io/StorageIO";
import {Body1, Caption1Strong, Spinner, Tab} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailTab} from "../../../../DetailViews";
import {
    UiHomeContentUserProductionDescription
} from "../../../../../data/description/ui/UiHomeContentUserProductionDescription";
import {UiHomeContentUserProductionDomain} from "../../../../../data/domain/ui/UiHomeContentUserProductionDomain";
import {
    UiHomeContentUserProductionDescriptor
} from "../../../../../data/descriptor/ui/UiHomeContentUserProductionDescriptor";
import {
    UiHomeContentUserProductionModificationValueObject
} from "../../../../../data/value-object/ui/UiHomeContentUserProductionModificationValueObject";
import {
    UiHomeContentUserProductionModificationSearchOption
} from "../../../../../data/search-option/ui/UiHomeContentUserProductionModificationSearchOption";
import {SearchIndex} from "../../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../../ListPageWrapper";
import {
    UiHomeContentUserProductionModificationDescription
} from "../../../../../data/description/ui/UiHomeContentUserProductionModificationDescription";
import {
    UiHomeContentUserProductionModificationDescriptor
} from "../../../../../data/descriptor/ui/UiHomeContentUserProductionModificationDescriptor";
import {Media, MediaFile} from "../../../../Media";

enum Panel {
    Default,
    UiHomeContentUserProductionModificationList
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ uiHomeContentUserProductionId: string }>()
    const item = useStatePair<UiHomeContentUserProductionValueObject | undefined>(undefined)
    const image = useStatePair<MediaFile | undefined>(undefined)

    useEffect(() => {
        if (params.uiHomeContentUserProductionId !== undefined) {
            const id = BigInt(params.uiHomeContentUserProductionId)
            UiHomeContentUserProductionIO
                .getById(id)
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
            MediaFile
                .createFromStorageKey(StorageKey.Ui.Home.Content.userProduction(id))
                .then(image.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('이미지를 찾을 수 없습니다. 이미지를 먼저 수정해주세요.')
                    document.location = document.location.pathname + '/edit'
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && image.value !== undefined && <Page {...props} item={item.value} image={image.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: UiHomeContentUserProductionValueObject
    image: MediaFile
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)

    return <>
        <div className={props.styles.row16}>
            <DetailTab
                {...props}
                panel={panel}>
                <Tab value={Panel.Default}>상세</Tab>
                <Tab value={Panel.UiHomeContentUserProductionModificationList}>수정 이력</Tab>
            </DetailTab>
            <DetailDefaultPanel
                {...props}
                visible={panel.value === Panel.Default}
                client={UiHomeContentUserProductionIO}
                description={UiHomeContentUserProductionDescription}
                properties={props => <PropertyBody {...props} />}
                panelChildren={<>
                    <Caption1Strong>이미지</Caption1Strong>
                    <Media
                        {...props}
                        source={props.image} />
                </>}
                storageKeys={() => StorageKey.Ui.Home.Content.userProduction(props.item.id)} />
            <UiHomeContentUserProductionModificationListPanel
                {...props}
                panel={panel.value} />
        </div>
    </>
}

type PropertyBodyProps = RouterProps & {
    item: UiHomeContentUserProductionDomain
    itemKey: keyof UiHomeContentUserProductionDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "displayOrder":
        case "url":
        case "createdAt":
        case "lastModifiedAt":
            return <Body1>{UiHomeContentUserProductionDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{UiHomeContentUserProductionDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}

type PanelProps = PageProps & {
    panel: Panel
}

function UiHomeContentUserProductionModificationListPanel(props: PanelProps) {
    const modifications = useStatePair<UiHomeContentUserProductionModificationValueObject[]>([])
    const modificationSearchOption: UiHomeContentUserProductionModificationSearchOption = { uiHomeContentUserProductionIdEq: props.item.id }
    const modificationSearchIndex = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {props.panel === Panel.UiHomeContentUserProductionModificationList && <>
            <ListPageWrapper
                {...props}
                client={UiHomeContentUserProductionModificationIO}
                items={modifications}
                option={modificationSearchOption}
                index={modificationSearchIndex}
                description={UiHomeContentUserProductionModificationDescription}
                descriptor={UiHomeContentUserProductionModificationDescriptor} />
        </>}
    </>
}